module.exports = __webpack_public_path__ + "img/6.cc85579b.png";